import { Button, DialogContent, DialogTitle, IconButton, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { X, Check } from "react-feather";
import styles from "./Popup.module.css";
import { authData } from "../GetAuth";
import { StorageSetItem, STORAGE_KEYS } from "../StorageComp";

const UpdateProfileForm = ({ setFormOpenUpdateProfile, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, userProfileData }) => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;

    const { handleSubmit, control, setValue, formState: { errors } } = useForm({
        mode: 'onChange',
        defaultValues: {
            user_type: ''
        }
    });

    useEffect(() => {
        if (auth) {
            setValue('name', auth?.name);
            setValue('email', auth?.email);
            setValue('phone', auth?.phone);
            setValue('user_type', auth?.user_type);
        }
    }, [userProfileData, setValue, auth])

    const onSubmit = (data) => {
        setLoading(true);
        setFormOpenUpdateProfile(false);

        axios.post(process.env.REACT_APP_API_URL + 'v1/users/update-profile/' + auth?.id, data, {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`
            }
        }).then(response => {
            setLoading(false);

            if (response.data.status === 'SUCCESS') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('success');
                const resData = response.data.data;

                let authTemp = auth;
                authTemp = { ...authTemp, ...resData };
                StorageSetItem(STORAGE_KEYS.AUTH, authTemp, 24 * 60 * 60 * 1000);
            }

            if (response.data.status === 'ERROR') {
                setSnackbarOpen(true);
                setSnackbarMessage(response.data.message);
                setSnackbarType('error');
            }
        }).catch(error => {
            setLoading(false);
            if (error && error.response && error.response.data && error.response.data.messages) {
                setSnackbarOpen(true);
                setSnackbarMessage(error.response.data.messages);
                setSnackbarType('error');
            }
        });
    }

    return (<>
        <DialogTitle id="customized-dialog-title" className={`${styles.PopupTitleBar}`}>
            Update Profile
            <IconButton onClick={(e) => setFormOpenUpdateProfile(false)} className={`${styles.PopupCloseBU}`} aria-label="Close"><Close /></IconButton>
        </DialogTitle>
        <DialogContent className={`${styles.PopupContent}`}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`${styles.FormMainRow}`}>
                    <div className={`${styles.FormGroupHalf}`}>
                        <Controller
                            name="name"
                            control={control}
                            rules={{ required: 'This field is Required' }}
                            render={({ field }) => <TextField {...field} label="Full Name*" variant="outlined" fullWidth />}
                        />
                        {errors.name && <span className={`${styles.ErrorM}`}>{errors?.name?.message}</span>}
                    </div>
                    <div className={`${styles.FormGroupHalf}`}>
                        <Controller
                            name="email"
                            control={control}
                            rules={{
                                required: 'This field is Required',
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Invalid email address"
                                }
                            }}
                            render={({ field }) => <TextField {...field} label="Email*" variant="outlined" disabled fullWidth />}
                        />
                        {errors.email && <span className={`${styles.ErrorM}`}>{errors?.email?.message}</span>}
                    </div>
                </div>

                <div className={`${styles.FormMainRow}`}>
                    <div className={`${styles.FormGroupFull}`}>
                        <Controller
                            name="phone"
                            control={control}
                            rules={{ required: 'This field is Required' }}
                            render={({ field }) => <TextField {...field} label="Phone*" variant="outlined" fullWidth />}
                        />
                        {errors.phone && <span className={`${styles.ErrorM}`}>{errors.phone.message}</span>}
                    </div>
                </div>

                <div className={`${styles.ButtonAction}`}>
                    <Button className={`${styles.CancelPopupBU}`} startIcon={<X size={16} />} onClick={(e) => setFormOpenUpdateProfile(false)}>Cancel</Button>
                    <Button className={`${styles.SubmitPopupBU}`} startIcon={<Check size={16} />} type="submit">Update</Button>
                </div>
            </form>
        </DialogContent>
    </>);
}

export default UpdateProfileForm;